module.exports = __webpack_public_path__ + "media/images/flags/it-58e75cebaf765e503d29181def4c9fee.svg";